//libs
import React from "react";
import { withSnackbar } from "notistack";

//constants
import { NOTIFICATION_TYPES, STRINGS } from "src/shared/constants";

//styles
import S from "./style.module.scss";

//components
import { BreadcrumbMenu } from "src/components";
import { SendMailForm } from "../SendEmailForm";

const SendEmail = ({ sendEmail = () => {}, enqueueSnackbar = () => {} }) => {
  const handleSubmit = async (values, resetForm) => {
    sendEmail({
      payload: {
        notificationMessage: values.body,
        notificationType: NOTIFICATION_TYPES.EMAIL,
      },
      success: (msg) => {
        enqueueSnackbar(msg, { variant: "success" });
        resetForm();
      },
      fail: (msg) => {
        enqueueSnackbar(msg, { variant: "error" });
      },
    });
  };

  return (
    <section className={S.section}>
      <BreadcrumbMenu title={STRINGS.CONFIGURE} subTitle={STRINGS.SEND_EMAIL} />

      <SendMailForm onSubmit={handleSubmit} />
    </section>
  );
};

export default withSnackbar(SendEmail);
